import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {Validators} from '@angular/forms';
//services
import { HttpTestService } from '../../services/http.service';
import { sessionServices } from '../../services/session.services';
import { newnscModel } from '../../models/newNSC/new.nsc.model';


@Component({
  selector: 'app-newnsc',
  templateUrl: './newnsc.component.html'
})
export class NewNscComponent implements OnInit {

   //variable deceleration

   public errorMsg : string = "";
   public successMsg : string = "";
   public sessionData : any;
   public newnscModel : newnscModel = new newnscModel;
   public serviceOn : boolean = false;
   public showTranscId : boolean;
   public hideOtp : boolean;
  
   public newNscPostData = {
     "newUserMob": null
   }

  
  
  constructor(public http: HttpTestService, public session: sessionServices, public router: Router) { 
    this.showTranscId = false;  
    this.hideOtp = true;
  }

  ngOnInit() {
                                       
  }

  sendMobileOtpReq = function(){
    var self = this;
    self.serviceOn = true;
    self.newNscPostData.newUserMob = self.newnscModel.newUserMob;
    this.showTranscId = true; 
    this.hideOtp = false;
   // self.router.navigateByUrl('/newNscRegCompnt');

  }
 
  sendTranscReq = function(){
    var self = this;
    self.router.navigateByUrl('/newNscRegCompnt');
  }



}


// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/newnsc/newnsc.component.ts